import { Injectable } from '@angular/core';

import { merge, Observable, tap } from 'rxjs';

import { Account } from '@shared/account/models';
import { WebSocketEventsEnum } from '@shared/websocket';
import { UserApiService } from '../../../../frontend-auth/src/lib/user-api.service';
import { AuthAccountQuery, AuthAccountStore } from '../states';
import { SocketService } from './socket.service';

@Injectable({providedIn: 'root'})
export class AuthAccountService {
  constructor(
    private readonly store: AuthAccountStore,
    private readonly query: AuthAccountQuery,
    private readonly userApiService: UserApiService,
    private readonly socketService: SocketService,
  ) {
  }

  load(): Observable<Account[]> {
    return this.userApiService.getAccounts()
      .pipe(tap(accounts => this.store.set(accounts)));
  }

  selectAll(): Observable<Account[]> {
    return this.query.selectAll();
  }

  getById(id: string): Account {
    return this.query.getEntity(id);
  }

  listenToChanges(): Observable<Account | string[]> {
    return merge(
      this.socketService.getEventStream<Account>(WebSocketEventsEnum.accountCreated)
        .pipe(tap(account => this.store.add(account))),
      this.socketService.getEventStream<Account>(WebSocketEventsEnum.accountUpdated)
        .pipe(tap(account => this.store.update(account.id, account))),
      this.socketService.getEventStream<string[]>(WebSocketEventsEnum.accountDeleted)
        .pipe(tap(ids => this.store.remove(ids))),
    );
  }

  reset() {
    return this.store.reset();
  }
}
